import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/src/app/learn/pests/PestsContent.tsx");
